import {
  Form,
  FormField,
  HiddenField,
  OtpInput,
  SubmitButton,
  toast,
} from "@bleu.builders/ui";
import { serialize } from "object-to-formdata";
import { usePostHog } from "posthog-js/react";
import React from "react";
import { useForm } from "react-hook-form";
import { redirectDocument, useSubmit } from "react-router-dom";

import { useAuthentication } from "#/contexts/AuthenticationContext";
import { client } from "#/utils/api-client";

import { LoginFormContainer } from "./Layout";

const action = async ({ request }) => {
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const redirectTo = params.get("redirectTo");

  const formData = await request.formData();
  const data = await client("/login", { body: formData, method: "PATCH" });

  if (!data.success) {
    toast({
      title: "Erro!",
      description: data.error,
      variant: "destructive",
    });
    return null;
  }

  if (redirectTo) {
    return redirectDocument(redirectTo);
  }

  return redirectDocument("/");
};

function StepTwoOTPInputForm() {
  const posthog = usePostHog();
  const { verification } = useAuthentication();
  const submit = useSubmit();
  const form = useForm({});

  const handleSubmit = async () => {
    const formData = serialize(form.getValues());
    submit(formData, { method: "post", encType: "multipart/form-data" });
  };

  return (
    <LoginFormContainer message="Digite o código encaminhado por email">
      <Form {...form} onSubmit={form.handleSubmit(handleSubmit)}>
        <HiddenField
          form={form}
          field={{
            name: "nopassword_verification[salt]",
            type: "hidden",
            value: verification?.salt,
          }}
        />
        <HiddenField
          form={form}
          field={{
            name: "nopassword_verification[data]",
            type: "hidden",
            value: verification?.data,
          }}
        />
        <div className="grid gap-2">
          <div className="grid gap-1">
            <FormField
              control={form.control}
              name="nopassword_verification[code]"
              render={({ field: formField }) => (
                <OtpInput
                  name={formField.name}
                  value={formField.value}
                  onOtpChange={formField.onChange}
                />
              )}
            />
          </div>
          <SubmitButton
            type="submit"
            submittingText="Carregando..."
            onClick={() => {
              posthog.capture(
                "auth:email_otp:client:user_submitted_otp_attempt",
              );
            }}
          >
            Continuar
          </SubmitButton>
        </div>
      </Form>
    </LoginFormContainer>
  );
}

StepTwoOTPInputForm.action = action;
export { StepTwoOTPInputForm };
